module.exports = __webpack_public_path__ + "static/media/title_mmandg.3e33d7e6.svg";